import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DashService } from '@modules/dash-board/dash.service';
import { ApiService } from '@services/api/api.service';
import { ProjectService } from '@services/api/project.service';
import { FeatureFlagService } from '@services/helpers/feature-flag.service';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { ReduxService } from '@state-management/redux.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-unit',
  templateUrl: './edit-unit.component.html',
  styleUrls: ['./edit-unit.component.scss'],
})
export class EditUnitComponent {
  @Input() selected_unit_id: any = null;
  @Input() project_id: any;
  @Input() editDetail: any = {};
  @Output() isUnitClosed = new EventEmitter<any>();
  @Output() lot_name_change = new EventEmitter<string>();
  @ViewChild('searchKeyword', { static: true }) searchKeyword: ElementRef;
  public active_project_store: any = null; // Active project store

  unit_status: any[] = [];
  unit_level: any[] = [];
  unit_type: any[] = [];
  unitForm: FormGroup;
  selected_eoi = null;
  unit_details = null;

  constructor(
    public lmService: LeadManagementService,
    private fb: FormBuilder,
    private toast: ToastrService,
    private _projectService: ProjectService,
    private Api: ApiService,
    private dash: DashService,
    private redux: ReduxService,
    public _featureFlagService: FeatureFlagService
  ) {
    this.unitForm = this.fb.group({
      lot_name: [null],
      projectid: [null],
      status_reason: [null],
      lot_price: 0,
      bed: [null],
      level: null,
      bath: [null],
      space: null,
      storage: null,
      study: null,
      aspect: null,
      total: 0,
      mpr: null,
      orientation: null,
      carpark_included: null,
      carpark_added: null,
      car_park_price: 0,
      storage_included: null,
      storage_added: null,
      storage_price: 0,
      internal_area: null,
      external_area: null,
      type: null,
      total_area: null,
      price_m2: 0,
      stop_notifications: null,
      created_at: null,
      preference_tags: null,
      extra: null,
      current_allocation: null,
      non_ypm_sale: false,
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Watch for changes to the selected EOI
    // When the selected EOI changes, get the project tags, car park storage, and project type
    // Patch the edit form with the selected EOI's data
    this.selected_eoi = changes?.editDetail?.currentValue;
    console.log('record:', this.selected_eoi);
    this.lmService.GetProjectList();
    this.patchEditForm(this.selected_eoi?._id);
  }

  mobToggle = false;

  ngOnInit(): void {
    // Get the project tags when the component is initialized
    this.getProjectTags();

    // Subscribe to screen size changes
    this.dash?.screenSize$?.subscribe(size => {
      // If the screen width is less than 630, toggle the mobile view
      if (size.width < 630) {
        this.mobToggle = true;
      } else {
        this.mobToggle = false;
      }
    });

    // Subscribe to active project updates from Redux store
    this.redux.getActiveProject().subscribe(value => {
      this.active_project_store = JSON.parse(JSON.stringify(value));
      console.log('this.active_project_store >>', this.active_project_store);
      this.project_id = this.active_project_store?._id;
    });
  }

  showProjectName() {
    let activeProject = this.active_project_store;
    return activeProject?.Project_Name
      ? activeProject?.Project_Name + ' - ' + (this.unitForm?.controls['lot_name'].value || this.selected_eoi?.lot_name)
      : '';
  }

  changeLotName() {
    /**
     * Emits the lot name change event
     * @param lot_name The new lot name
     */
    this.lot_name_change.emit(this.unitForm.controls['lot_name'].value);
  }

  disabled_carpark_price: string = null;

  patchEditForm(id) {
    /**
     * Get the project lot data by id
     * @param id The project lot id
     */
    this._projectService.getProjectLotById(id).subscribe({
      next: response => {
        // Patch the unit form values with the response data
        if (response?.data?.carpark_info?.length > 0) {
          let car_park_included = response?.data?.carpark_info
            .filter(ele => ele?.included == 'Yes' && !ele?.car_park_no)
            .map(item => item.carpark_lot);
          let car_park_added = response?.data?.carpark_info.filter(ele => ele?.included == 'No' && !ele?.car_park_no).map(item => item.carpark_lot);
          response['data'] = {
            ...response?.data,
            carpark_included: car_park_included,
            carpark_added: car_park_added,
          };
        }

        if (response?.data?.storage_info?.length > 0) {
          let storage_included = response?.data?.storage_info.filter(ele => ele?.included == 'Yes').map(item => item.storage_no);
          let storage_add = response?.data?.storage_info.filter(ele => ele?.included == 'No').map(item => item.storage_no);
          response['data'] = {
            ...response?.data,
            storage_included: storage_included,
            storage_added: storage_add,
          };
        }

        this.unit_details = response['data'];

        console.log('response >> ', response['data']);

        this.unitForm.patchValue(response?.data);
        this.getCarParkStorage();
        this.getProjectType();
        this.getProjectLevel();
      },
    });
  }

  clear(item, method) {
    console.log('value >>:', item, 'Param >>:', method);
    if (method == 'carpark_included') {
      let car_park = this.unitForm.controls['carpark_included'].value;
      this.unitForm.patchValue({
        carpark_included: car_park?.filter(ele => ele !== item),
      });
      this.changeCarStorage(null, 'car_park_include');
    } else if (method == 'carpark_added') {
      let car_park = this.unitForm.controls['carpark_added'].value;
      this.unitForm.patchValue({
        carpark_added: car_park?.filter(ele => ele !== item),
      });
      this.changeCarStorage(car_park, 'car_park');
    } else if (method == 'storage_included') {
      let car_park = this.unitForm.controls['storage_included'].value;
      this.unitForm.patchValue({
        storage_included: car_park?.filter(ele => ele !== item),
      });
      this.changeCarStorage(null, 'storage_include');
    } else if (method == 'storage_added') {
      let storage = this.unitForm.controls['storage_added'].value;
      this.unitForm.patchValue({
        storage_added: storage?.filter(ele => ele !== item),
      });

      this.changeCarStorage(storage, 'storage');
    }
  }

  changeCarStorage(_eve, method) {
    /**
     * Updates the unit form based on the event and the method.
     * The methods are:
     * - 'car_park': updates the car park price
     * - 'storage': updates the storage price
     * @param eve the event
     * @param method the method to use
     */

    if (method == 'car_park') {
      let selected = this.unitForm.controls['carpark_added'].value;
      const result = this.copy_carpark_list.filter(
        car => selected.some(str => str === car.carpark_lot) // strict equality check
      );
      console.log('car_park >>:', result);
      var total = 0;
      result?.forEach(ele => {
        ele?.price ? (total += Number(ele?.price)) : (total = +0);
      });
      // Update the car park price
      this.unitForm.patchValue({
        car_park_price: total,
      });
    } else if (method == 'storage') {
      // Update the storage price
      let selected = this.unitForm.controls['storage_added'].value;
      const result = this.copy_storage_list.filter(
        car => selected.some(str => str === car.storage_no) // strict equality check
      );
      console.log('storage >>:', result);
      var total = 0;
      result?.forEach(ele => {
        ele?.price ? (total += Number(ele?.price)) : (total = +0);
      });
      // Update the car park price
      this.unitForm.patchValue({
        storage_price: total,
      });
    }

    let c_include = this.unitForm.controls['carpark_included'].value ? this.unitForm.controls['carpark_included'].value?.length : 0;
    let c_added = this.unitForm.controls['carpark_added'].value ? this.unitForm.controls['carpark_added'].value?.length : 0;
    let s_include = this.unitForm.controls['storage_included'].value ? this.unitForm.controls['storage_included'].value?.length : 0;
    let s_added = this.unitForm.controls['storage_added'].value ? this.unitForm.controls['storage_added'].value?.length : 0;

    this.unitForm.patchValue({
      space: c_include + c_added,
      storage: s_include + s_added,
    });

    // Calculate the total price

    let add_price =
      (this.unitForm.controls['lot_price'].value ? this.unitForm.controls['lot_price'].value : 0) +
      (this.unitForm.controls['car_park_price'].value ? this.unitForm.controls['car_park_price'].value : 0) +
      (this.unitForm.controls['storage_price'].value ? this.unitForm.controls['storage_price'].value : 0);
    // Update the total price
    this.unitForm.patchValue({
      total: add_price,
    });
  }

  calculateArea(value, param: string) {
    let lot_price = this.unitForm.controls['lot_price'].value ? this.unitForm.controls['lot_price'].value : 0;
    if (param == 'internal_area') {
      this.unitForm.patchValue({
        internal_area: value,
      });

      let internal_area = this.unitForm.controls['internal_area'].value ? this.unitForm.controls['internal_area'].value : 0;
      let external_area = this.unitForm.controls['external_area'].value ? this.unitForm.controls['external_area'].value : 0;
      let add_area = internal_area + external_area;

      this.unitForm.patchValue({
        total_area: add_area,
        price_m2: (lot_price / internal_area)?.toFixed(2),
      });
    } else if (param == 'external_area') {
      this.unitForm.patchValue({
        external_area: value,
      });

      let internal_area = this.unitForm.controls['internal_area'].value ? this.unitForm.controls['internal_area'].value : 0;
      let external_area = this.unitForm.controls['external_area'].value ? this.unitForm.controls['external_area'].value : 0;
      let add_area = internal_area + external_area;

      this.unitForm.patchValue({
        total_area: add_area,
      });
    } else if (param == 'total_area') {
      this.unitForm.patchValue({
        total_area: value,
      });
    }
  }

  updatePrice(value, param: string) {
    if (param == 'lot_price') {
      this.unitForm.patchValue({
        lot_price: value,
      });
      let lot_price = this.unitForm.controls['lot_price'].value ? this.unitForm.controls['lot_price'].value : 0;
      let internal_area = this.unitForm.controls['internal_area'].value ? this.unitForm.controls['internal_area'].value : 0;
      this.unitForm.patchValue({
        price_m2: (lot_price / internal_area)?.toFixed(2),
      });
    } else if (param == 'car_park_price') {
      let lot_price = this.unitForm.controls['lot_price'].value ? this.unitForm.controls['lot_price'].value : 0;
      let storage_price = this.unitForm.controls['storage_price'].value ? this.unitForm.controls['storage_price'].value : 0;

      this.unitForm.patchValue({
        car_park_price: value,
        total: lot_price + value + storage_price,
      });
    } else if (param == 'storage_price') {
      let lot_price = this.unitForm.controls['lot_price'].value ? this.unitForm.controls['lot_price'].value : 0;
      let car_park_price = this.unitForm.controls['car_park_price'].value ? this.unitForm.controls['car_park_price'].value : 0;

      this.unitForm.patchValue({
        storage_price: value,
        total: lot_price + value + car_park_price,
      });
    } else if (param == 'total') {
      this.unitForm.patchValue({
        total: value,
      });
    } else if (param == 'price_m2') {
      this.unitForm.patchValue({
        price_m2: value,
      });
    }
  }

  saveUnit(method) {
    /**
     * Save the unit form data
     * @param method The method to use for saving the data, either 'update' or 'create'
     */
    let form_data = this.unitForm.value;
    if (this.selected_unit_id) {
      // If the selected unit id exists, update the bulk work record
      let form = {
        record: Object.fromEntries(
          Object.entries(form_data).filter(
            ([key, value]) =>
              // Unticking Non YPM Sale sends `false`, which the falsy filter below would otherwise drop — so the
              // flag could be set but never cleared. Only a control the user touched is sent.
              (key === 'non_ypm_sale' && this.unitForm.controls['non_ypm_sale'].dirty) ||
              (value != 0 && value != null && value !== '' && key !== '' && key !== 'preference_tag' && key !== 'is_read')
          )
        ),
        office_id: this.Api.getOfficeId(),
        selected_records: this.selected_unit_id,
        module: 'byd_units',
      };
      this._projectService.bulkEditEoi(form).subscribe({
        next: async _ => {
          this.toast.success('Update successfully');
          if (method == 'create') {
            // Reset the unit form after saving
            this.unitForm.reset();
            let tab = this.lmService.tab_levels.find(el => el?.name?.toLowerCase()?.includes('lot'));
            if (tab) {
              let ind = this.lmService.tab_levels.indexOf(tab);
              this.isUnitClosed.emit({ level: tab, index: ind });
            }
          }
        },
      });
    } else {
      // If the selected unit id does not exist, create a new record
      if (this.unitForm.valid) {
        let carpark_included_value = this.unitForm.controls['carpark_included'].value;
        let carpark_added_value = this.unitForm.controls['carpark_added'].value;
        let storage_included_value = this.unitForm.controls['storage_included'].value;
        let storage_added_value = this.unitForm.controls['storage_added'].value;

        let car_park_included =
          carpark_included_value?.length > 0
            ? carpark_included_value?.map(ele => {
                ele = { carpark_lot: ele, type: 'included' };
                return ele;
              })
            : [];
        let car_park_Added =
          carpark_added_value?.length > 0
            ? carpark_added_value?.map(ele => {
                ele = { carpark_lot: ele, type: 'added' };
                return ele;
              })
            : [];
        let storage_included =
          storage_included_value?.length > 0
            ? storage_included_value?.map(ele => {
                ele = { storage_no: ele, type: 'included' };
                return ele;
              })
            : [];
        let storage_Added =
          storage_added_value?.length > 0
            ? storage_added_value?.map(ele => {
                ele = { storage_no: ele, type: 'added' };
                return ele;
              })
            : [];

        let id = this.selected_eoi?._id;
        form_data['office_id'] = this.Api.getOfficeId();
        form_data['tags'] = [];
        form_data['car_park_no'] = [...car_park_included, ...car_park_Added];
        form_data['storage_no'] = [...storage_included, ...storage_Added];
        delete form_data['carpark_included'];
        delete form_data['carpark_added'];
        delete form_data['storage_included'];
        delete form_data['storage_added'];
        this._projectService.updateProjectLotById(id, form_data).subscribe({
          next: _ => {
            this.toast.success('Update successfully');
            this.lmService.updateProjectSummary(true);
            if (method == 'create') {
              // Reset the unit form after saving
              this.unitForm.reset();
              let tab = this.lmService.tab_levels.find(el => el?.name?.toLowerCase()?.includes('lot'));
              if (tab) {
                let ind = this.lmService.tab_levels.indexOf(tab);
                this.isUnitClosed.emit({ level: tab, index: ind });
              }
            }
          },
        });
      } else {
        // If the unit form is invalid, show an error message and validate the fields
        this.toast.error('Fill out the required field');
        let fields: any = Object.entries(this.unitForm.controls)
          .reduce((acc, [key, value]) => {
            if (value.status === 'INVALID') {
              acc.push(key);
            }
            return acc;
          }, [])
          ?.filter(error_field => error_field !== undefined && error_field !== null);
        fields && this.validateFieldsOnRequest(fields);
      }
    }
  }

  validateFieldsOnRequest(fields: any[] = []) {
    /**
     * Validates specified fields, sets validators, and updates control validity.
     *
     * @param fields - An array of field error objects to validate.
     */
    if (fields?.length > 0) {
      // Loop through the fields which have errors and add the required validator to
      // the fields which have errors.
      fields?.forEach(field_error => {
        this.unitForm?.controls?.[field_error]?.setValidators([Validators.required]);
        this.unitForm?.controls?.[field_error]?.updateValueAndValidity();
      });
    }
  }

  closeUnit() {
    /**
     * Resets the unit form and emits the close event for the unit tab when the close button is clicked.
     *
     * @param e - The click event.
     */
    this.unitForm.reset();
    // Find the tab level with the name 'lot'
    let tab = this.lmService.tab_levels.find(el => el?.name?.toLowerCase()?.includes('lot'));
    if (tab) {
      // Find the index of the tab level
      let ind = this.lmService.tab_levels.indexOf(tab);
      // Emit the close event for the tab level
      this.isUnitClosed.emit({ level: tab, index: ind });
    }
  }

  car_park_list: any[] = [];
  copy_carpark_list: any[] = [];
  storage_list: any[] = [];
  copy_storage_list: any[] = [];

  getCarParkStorage() {
    /**
     * Fetches car park and storage data for the given ID, and filters out items with undefined or null lots.
     * @param id The ID to fetch car park and storage data for.
     */
    let id = this.project_id ? this.project_id : this.unit_details?.projectid;

    this._projectService.getCarParkStorage(id).subscribe({
      next: response => {
        this.car_park_list = [];
        this.storage_list = [];
        this.copy_carpark_list = [];
        this.copy_storage_list = [];
        this.copy_carpark_list = response?.data[0].data.car_park;
        this.copy_storage_list = response?.data[0].data.storage;
        this.car_park_list = response?.data[0].data.car_park?.filter(car => car?.lot == '' || car?.lot == null);
        this.storage_list = response?.data[0].data.storage?.filter(storage => storage?.lot == '' || storage?.lot == null);
      },
    });
  }

  getProjectType() {
    let id = this.project_id ? this.project_id : this.unit_details?.projectid;
    this._projectService.getProjectType(id).subscribe({
      next: response => {
        // Update the unit_type array with response data if available
        this.unit_type = response?.data?.length > 0 ? response?.data : [];
      },
    });
  }
  getProjectLevel() {
    let id = this.project_id ? this.project_id : this.unit_details?.projectid;
    this._projectService.getProjectLevel(id).subscribe({
      next: response => {
        this.unit_level = response?.data?.level_order?.length > 0 ? response?.data?.level_order : [];
      },
    });
  }
  getProjectTags() {
    /**
     * Fetches project tags and processes them to update unit status, unit level, and preference tags.
     */
    this.redux.getTags(this.Api.getOfficeId(), true, 'project').subscribe({
      next: response => {
        let tags_data = [...response?.data];

        // Iterate over each tag in the types array
        tags_data[0]?.types.forEach(tag => {
          // Process project-status tags
          if (tag?.slug == 'project-status') {
            this.unit_status = [...tag?.data]
              .sort((a, b) => a?.tag_name.localeCompare(b?.tag_name))
              .map(el => {
                // Disable tags that are not 'for sale', 'available', or 'withheld'
                if (
                  el.tag_name.toLowerCase() !== 'for sale' &&
                  el.tag_name.toLowerCase() !== 'available' &&
                  el.tag_name.toLowerCase() != 'withheld' &&
                  el.tag_name.toLowerCase() != 'developer hold'
                ) {
                  el = { ...el, disabled: true };
                }
                return el;
              });

            // Separate disabled and unDisabled statuses
            let disabled_status = this.unit_status?.filter(el => el?.disabled);
            let unDisabledStatus = this.unit_status?.filter(el => !el?.disabled);
            // Reorder unit_status to have unDisabled statuses first
            this.unit_status = [...unDisabledStatus, ...disabled_status];
          }
        });
      },
    });
  }
}
